import React, { useState, useEffect } from "react";

const characterCount = 5;
const backgroundImage = "/images/pg_upload/pit-background.png";
const characterBasePath = "/images/pg_upload/";

const Carousel = () => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % characterCount);
        setFade(true); // Fade in new character
      }, 1600); // Fade duration doubled from 800ms to 1600ms
    }, 10000); // Interval doubled from 5000ms to 10000ms
    return () => clearInterval(timer);
  }, []);

  const characterImages = Array.from(
    { length: characterCount },
    (_, i) => `${characterBasePath}_${i + 1}_char.png`
  );

  return (
    <div style={{ position: "relative", width: "100%", maxWidth: 420, margin: "0 auto", marginBottom: 24 }}>
      <img
        src={backgroundImage}
        alt="Cliff Background"
        style={{
          width: "100%",
          borderRadius: 8,
          display: "block",
        }}
      />
      <img
        src={characterImages[index]}
        alt={`Climber ${index + 1}`}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: 8,
          opacity: fade ? 1 : 0,
          transition: "opacity 0.8s", // Transition duration doubled from 0.4s to 0.8s
          pointerEvents: "none",
        }}
      />
      <div style={{ marginTop: 8, textAlign: "center" }}>
        {characterImages.map((_, i) => (
          <span
            key={i}
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: i === index ? "#4caf50" : "#ccc",
              margin: "0 4px",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;